export default "__VITE_ASSET____AC1ony__"